import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { StockToteListPagination, StockToteListSearchCriteria } from '../models/stock-tote-list.model';
import { StockToteSummaryResponse } from '../models/stock-tote.model';

@Injectable({
  providedIn: 'root'
})
export class StockToteService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.stockTote;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  summary(): Observable<StockToteSummaryResponse> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.summary, {
      storeNo
    });

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body'
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getList(criteria: StockToteListSearchCriteria): Observable<StockToteListPagination> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.list, {
      storeNo
    });
    const params = this.getParams(criteria, true);
    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }
}
